import { Decimal } from '@cosmjs/math';
import { mapLimit, asyncify } from 'async';
import _ from 'lodash';
import { RootStoreInstance } from '@stores';
import { API_URL_EXPLORER, MILLION_MULTIPLIER, RPC_URL_DEV } from '@constants/system';
import utils, { findAttribute, findAttributeSingle, findEvent, numberWithSeparator, splitCamelCase } from '@utils';
import axios from 'axios';
import { logs } from '@cosmjs/stargate';

const getInfoTransactions = ({ data }) => {
  const txsInfo = [];
  data.forEach(transaction => {
    let isTxTypeSend = false;
    const parsedRawLog = [transaction];
    const txTransferAmountArray = findAttribute(parsedRawLog, 'transfer', 'amount');
    const txTransferAmount = txTransferAmountArray?.length
      ? txTransferAmountArray.map((txTransferAmount) => {
          return txTransferAmount?.length
            ? txTransferAmount.map((amount) => {
                return amount
                  ? amount.slice(-6) === 'uhoney'
                    ? `Transfer: ${parseFloat(amount) / MILLION_MULTIPLIER} honey\n`
                    : `Transfer: ${parseFloat(amount)} cone\n`
                  : '';
              })
            : '';
        })
      : '-';

    const txDelegateAmountArray = findAttribute(parsedRawLog, 'delegate', 'amount');
    const txDelegateAmount = txDelegateAmountArray?.length
      ? txDelegateAmountArray.map((txDelegateAmount) => {
          return txDelegateAmount?.length
            ? txDelegateAmount.map((amount) => {
                return amount
                  ? amount.slice(-6) === 'uhoney'
                    ? `Delegate: ${parseFloat(amount) / MILLION_MULTIPLIER} honey\n`
                    : `Delegate: ${parseFloat(amount)} cone\n`
                  : '';
              })
            : '';
        })
      : '-';

    const txBurnAmountArray = findAttribute(parsedRawLog, 'burn', 'amount');
    const txBurnAmount = txBurnAmountArray?.length
      ? txBurnAmountArray.map((txBurnAmount) => {
          return txBurnAmount?.length
            ? txBurnAmount.map((amount) => {
                return amount
                  ? amount.slice(-6) === 'uhoney'
                    ? `Burn: ${parseFloat(amount) / MILLION_MULTIPLIER} honey\n`
                    : `Burn: ${parseFloat(amount)} cone\n`
                  : '';
              })
            : '';
        })
      : '-';

    const value = [...txTransferAmount, ...txDelegateAmount, ...txBurnAmount];

    const txActionArray = findAttribute(parsedRawLog, 'message', 'action');
    const txAction = txActionArray?.length
      ? txActionArray.map((txAction) => {
          const txActionText = txAction?.length
            ? txAction.map((action) => {
                return `${splitCamelCase(
                  action
                    .replace(/\/cosmos.distribution.v1beta1.Msg/gi, '')
                    .replace(/\/cosmos.bank.v1beta1.Msg/gi, '')
                    .replace(/\/cosmos.staking.v1beta1.Msg/gi, '')
                    .replace(/_/gi, ' '),
                )}\n`;
              })
            : '';
          if (txActionText.includes(' send\n')) {
            isTxTypeSend = true;
          }
          return txActionText;
        })
      : '-';

    const txMessageRawArray = findEvent(parsedRawLog, 'message');
    const txMessageArray = txMessageRawArray?.length
      ? txMessageRawArray[0].filter(
          (event) => event.key !== 'action' && event.key !== 'module',
        )
      : '-';
    if (isTxTypeSend) {
      const txTransferRecipientArray = findAttribute(
        parsedRawLog,
        'transfer',
        'recipient',
      );
      if (txTransferRecipientArray?.length && txTransferRecipientArray[0]?.length) {
        txMessageArray.push({
          key: 'recipient',
          value: txTransferRecipientArray[0][0],
        });
      }
    }
    const txInfo = {
      txInfo: [
        // TODO text-overflow: ellipsis
        [...transaction.txHash.slice(0, 30), '...'],
        numberWithSeparator(transaction.height),
        value.find((item) => item) ? value : '-',
        txAction,
      ],
      txDescription: txMessageArray,
    };
    txsInfo.push(txInfo);

  });

  return txsInfo;
} 

// Balance

export const getBalance = async ({ address }) => {
  let { cosmos } = RootStoreInstance.anonymousClient;
  if (RootStoreInstance.isDevelop) {
    ({ cosmos } = await utils.createAnonymousClient(RPC_URL_DEV));
  }
  const response = await cosmos.queryClient.bank.allBalances(address);
  const honey = _.find(response, { denom: 'uhoney' }) || { amount: 0 };
  const cone = _.find(response, { denom: 'cone' }) || { amount: 0 };
  return {
    honey: honey.amount / MILLION_MULTIPLIER,
    cone: cone.amount,
  };
};

export const getTotalSupplyHoney = async () => {
  const response = await RootStoreInstance.anonymousClient.cosmos.queryClient.bank.supplyOf(
    'uhoney',
  );
  return response.amount / MILLION_MULTIPLIER;
};

export const getTotalSupplyCones = async () => {
  const response = await RootStoreInstance.anonymousClient.cosmos.queryClient.bank.supplyOf('cone');
  return response.amount;
};

// Transactions

export const getLatestTransactions = async (page = 1, blockHeight = 0, per_page = 10) => {
  const response = await RootStoreInstance.anonymousClient.cosmos.forceGetTmClient().txSearch({
    query: `message.action EXISTS AND tx.height >= ${blockHeight}`,
    // query: `message.action EXISTS AND tx.height >= ${blockHeight} AND tx.height < ${
    //   blockHeight + 1000
    // }`,
    order_by: 'desc',
    page: page + 1,
    per_page,
  });
  return response;
};
// /* eslint-disable */
export const getLatestTransactionsNew = async ({ page = 0, perPage = 10, blockHeight = 0 }) => {
  // const filter = `{"action": "/cosmos.bank.v1beta1.MsgSend", "events.attributes.value": ${address}}`;
  const tokenName = 'uhoney';
  const api = axios.create({
    baseURL: API_URL_EXPLORER,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  });
  try {
    const response = await api.get(`txmessages/list?filter={}&page=${page}&limit=${perPage}&sort[height]=-1`);
    if (response.data.error) {
      throw response.data.error;
    }
    const data = await response.data;
    const txsInfo = getInfoTransactions({ data });
    return { txsInfo };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTotalTransactions = async (page = 1, per_page = 10) => {
  const response = await RootStoreInstance.anonymousClient.cosmos.forceGetTmClient().txSearch({
    query: `message.action EXISTS`,
    order_by: 'desc',
    page: page + 1,
    per_page,
  });
  return response;
};

/* old getTransactions */
/* export const getTransactions = async (page = 1, address = '', per_page = 10, blockHeight = 0, ) => {
  // https://docs.tendermint.com/master/rpc/#/Info/tx_search
  const response = await RootStoreInstance.anonymousClient.cosmos.forceGetTmClient().txSearch({
    query: `message.action EXISTS AND message.sender = '${address}' AND tx.height >= ${blockHeight}`,
    // query: `message.action EXISTS OR message.creator = '${address}' OR message.receiver = '${
    //   address
    // }'`,
    order_by: 'desc',
    page: page + 1,
    per_page,
  });
  return response;
}; */

export const getTransactionsNew = async ({ address, page = 0, limit = 5 }) => {
  const filter = `{"events.attributes":{"$elemMatch":{"value":"${address}"}}}`;
  const api = axios.create({
    baseURL: API_URL_EXPLORER,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  });
  try {
    const response = await api.get(`txmessages/list?filter=${filter}&page=${page}&limit=${limit}&sort[height]=-1`);
    if (response.data.error) {
      throw response.data.error;
    }
    const data = await response.data;
    const txsInfo = getInfoTransactions({ data });
    return { txsInfo };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/* new getTransactions */
export const getTransactions = async (
  address = '',
  per_page = 10,
  higherBlockHeight = 10000,
  lowerBlockHeight = 0,
) => {
  let currentLowerBlockHeight = lowerBlockHeight;
  let finalTxs;
  let finalTotalCount;
  let finalLowerBlockHeight;
  do {
    // eslint-disable-next-line no-await-in-loop
    const { totalCount, txs } = await RootStoreInstance.anonymousClient.cosmos
      .forceGetTmClient()
      .txSearch({
        query: `message.action EXISTS AND message.sender = '${address}' AND tx.height <= ${higherBlockHeight} AND tx.height >= ${
          currentLowerBlockHeight >= 0 ? currentLowerBlockHeight : 0
        }`,
        order_by: 'desc',
        page: 1,
        per_page,
      });
    finalTxs = txs;
    finalTotalCount = totalCount;
    if (finalTotalCount > 100) {
      currentLowerBlockHeight += 1000;
    }
    if (finalTotalCount < 10) {
      if (currentLowerBlockHeight >= 10000) {
        currentLowerBlockHeight -= 10000;
      } else {
        currentLowerBlockHeight = 0;
      }
    }
    finalLowerBlockHeight = currentLowerBlockHeight;
  } while (finalTotalCount < 10 || (finalTotalCount > 100 && currentLowerBlockHeight > 0));

  return {
    finalTotalCount,
    finalTxs,
    requestedHigherBlockHeight: higherBlockHeight,
    finalLowerBlockHeight,
  };
};

/* The method is working, but long in time */
// export const getAllTransactions = async () => {
//   const { txs } = await RootStoreInstance.anonymousClient.cosmos
//     .forceGetTmClient()
//     .txSearchAll({ query: 'message.action EXISTS', order_by: 'desc' });
//   return txs;
// };

export const getLatestBlocks = async (minHeight = undefined, maxHeight = undefined) => {
  const blockchain = await RootStoreInstance.anonymousClient.cosmos
    .forceGetTmClient()
    .blockchain(minHeight, maxHeight);
  return blockchain;
};

// Statistics

export const getBlockHeights = async () => {
  const response = await RootStoreInstance.anonymousClient.cosmos.getHeight();
  return response;
};

export const getAllAirHistory = async ({ offset = 0, limit = 50 }) => {
  const response = await RootStoreInstance.anonymousClient.bearsQueries.AirHistoryAll({
    pagination: {
      key: [],
      offset: 0 + offset,
      limit,
      countTotal: true,
      reverse: true,
    },
  });
  return response;
};

export const getLastAirInfo = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.ShowLastAirInfo({});
    return {
      consume: Decimal.fromAtomics(response.consume, 18).toFloatApproximation(),
      supply: Decimal.fromAtomics(response.supply, 18).toFloatApproximation(),
      count: Decimal.fromAtomics(response.count, 18).toFloatApproximation(),
      purity: Decimal.fromAtomics(response.purity, 18).toFloatApproximation(),
    };
  } catch (err) {
    return { err };
  }
};

// Bear statistics

export const getHoneyPowerBear = async ({ bearId }) => {
  const response = await RootStoreInstance.anonymousClient.bearsQueries.ShowHoneyPowerByBearId({
    bearId,
  });
  return {
    result:
      Decimal.fromAtomics(response.honeyPower, 18).toFloatApproximation() / MILLION_MULTIPLIER,
    code: response.code,
  };
};

export const getHoneyPowerBeePerBlock = async ({ beeType }) => {
  const response = await RootStoreInstance.anonymousClient.bearsQueries.ShowHoneyPowerByBeeType({
    beeType,
  });
  return {
    result:
      Decimal.fromAtomics(response.honeyPower, 18).toFloatApproximation() / MILLION_MULTIPLIER,
    code: 0,
  };
};

export const getBearName = async (name) => {
  const { bearNames } = await RootStoreInstance.anonymousClient.bearsQueries.BearNames({
    name,
  });
  return bearNames;
};

export const getBearsId = async ({ address }) => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.AddressBears({
      address,
    });
    return response.addressBears;
  } catch (err) {
    return { err };
  }
};

export const getParams = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.Params({});
    return response.params;
  } catch (err) {
    return { err };
  }
};

export const getAllBears = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.BearsAll({
      pagination: {
        key: [],
        offset: 0,
        limit: 1,
        countTotal: true,
        reverse: false,
      },
    });
    return response;
  } catch (err) {
    return { err };
  }
};
export const getAllBees = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.BeesAll({
      pagination: {
        key: [],
        offset: 0,
        limit: 1,
        countTotal: true,
        reverse: false,
      },
    });
    return response;
  } catch (err) {
    return { err };
  }
};
export const getAllTrees = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.TreesAll({
      pagination: {
        key: [],
        offset: 0,
        limit: 1,
        countTotal: true,
        reverse: false,
      },
    });
    return response;
  } catch (err) {
    return { err };
  }
};
export const getAllApiaries = async () => {
  try {
    const response = await RootStoreInstance.anonymousClient.bearsQueries.ApiariesAll({
      pagination: {
        key: [],
        offset: 0,
        limit: 1,
        countTotal: true,
        reverse: false,
      },
    });
    return response;
  } catch (err) {
    return { err };
  }
};

export const getBearsInfo = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Bears } = await RootStoreInstance.anonymousClient.bearsQueries.Bears({
          id,
        });
        return Bears;
      }),
    );
  } catch (err) {
    return { err };
  }
};

export const getApiaries = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Apiaries } = await RootStoreInstance.anonymousClient.bearsQueries.Apiaries({
          id,
        });
        const { honeyPower } =
          await RootStoreInstance.anonymousClient.bearsQueries.ShowHoneyPowerByApiaryId({
            apiaryId: id,
          });
        const { countHoney } =
          await RootStoreInstance.anonymousClient.bearsQueries.CalculateHoneyInApiary({
            apiaryId: id,
          });
        Apiaries.honeyPower =
          Decimal.fromAtomics(honeyPower, 18).toFloatApproximation() / MILLION_MULTIPLIER;
        Apiaries.countHoney =
          Decimal.fromAtomics(countHoney, 18).toFloatApproximation() / MILLION_MULTIPLIER;
        return Apiaries;
      }),
    );
  } catch (err) {
    return { err };
  }
};

export const getTrees = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Trees } = await RootStoreInstance.anonymousClient.bearsQueries.Trees({
          id,
        });
        return Trees;
      }),
    );
  } catch (err) {
    return { err };
  }
};

export const getFields = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Fields } = await RootStoreInstance.anonymousClient.bearsQueries.Fields({
          id,
        });
        return Fields;
      }),
    );
  } catch (err) {
    return { err };
  }
};

export const getDecorations = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Decorations } = await RootStoreInstance.anonymousClient.bearsQueries.Decorations({
          id,
        });
        return Decorations;
      }),
    );
  } catch (err) {
    return { err };
  }
};

export const getBees = async ({ ids = [] }) => {
  try {
    return await mapLimit(
      ids,
      5,
      asyncify(async (id) => {
        const { Bees } = await RootStoreInstance.anonymousClient.bearsQueries.Bees({
          id,
        });
        return Bees;
      }),
    );
  } catch (err) {
    return { err };
  }
};

// Staking

export const getValidators = async ({ status = 'BOND_STATUS_BONDED' }) => {
  const response = await RootStoreInstance.anonymousClient.cosmos.queryClient.staking.validators(
    status,
  );
  return response;
};

export const getAllStakedAndUnstakingCones = async () => {
  const { pool } = await RootStoreInstance.anonymousClient.cosmos.queryClient.staking.pool();
  return pool;
};

export const getStakedCones = async ({ address, generalCones = false }) => {
  const response =
    await RootStoreInstance.anonymousClient.cosmos.queryClient.staking.delegatorDelegations(
      address,
    );
  if (!generalCones) {
    return response.delegationResponses;
  }
  return response.delegationResponses.reduce((sum, val) => {
    return sum + Number(val.balance.amount);
  }, 0);
};

export const getTotalStakingRewards = async ({ address }) => {
  const response =
    await RootStoreInstance.anonymousClient.cosmos.queryClient.distribution.delegationTotalRewards(
      address,
    );
  return response.total.map((value) => {
    return {
      amount: Decimal.fromAtomics(value.amount, 18).toFloatApproximation(),
      denom: value.denom,
    };
  });
};

export const getUnstakingCones = async ({ address }) => {
  const response =
    await RootStoreInstance.anonymousClient.cosmos.queryClient.staking.delegatorUnbondingDelegations(
      address,
    );

  return response.unbondingResponses.reduce((sum, val) => {
    const currentSum = val.entries.reduce((sum, val) => {
      return sum + Number(val.balance);
    }, 0);
    return sum + currentSum;
  }, 0);
};

export default {
  getBalance,
  getTotalSupplyHoney,
  getTotalSupplyCones,
  getLatestTransactions,
  getLatestTransactionsNew,

  // getAllTransactions,
  getLatestBlocks,
  getHoneyPowerBear,
  getHoneyPowerBeePerBlock,
  getLastAirInfo,
  getBearsId,
  getBearsInfo,
  getFields,
  getTrees,
  getApiaries,
  getDecorations,
  getBees,
  getParams,
  getValidators,
  getBlockHeights,
  getAllBears,
  getAllBees,
  getAllTrees,
  getAllApiaries,
  getAllAirHistory,
  getAllStakedAndUnstakingCones,
  getStakedCones,
  getTotalStakingRewards,
  getUnstakingCones,

  getBearName,
  getTransactions,
  getTransactionsNew,
  getTotalTransactions,
};
